import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "shards-react";
import styled from "styled-components";
import baseUrl from "config/baseUrl";
import { Loading } from "views/Indicators/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-regular-svg-icons";
import { useTranslation } from "react-i18next";
import Layout from "shared/container/Layout";

const axios = require("axios").default;

const lawContent = styled.div`
  padding: 30px 0;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  @media only screen and (max-width: 786px) {
    flex-direction: column;
    & a {
      flex: 1;
      margin: 10px 0;
    }
  }
`;
const StyledMedia = styled.div`
  display: flex;
  align-items: center;
  color: #000;
  margin-bottom: 10px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 5px 20px;
  .media-icon {
    padding: 20px;
    svg {
      height: 45px;
    }
  }
  .media-body-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .media-body-subtitle {
    color: #818181;
  }
  .media-body {
    line-height: 2.5rem;
    margin-right: 20px;
  }
  .file {
    svg {
      margin-top: 5px;
      height: 35px;
      color: #868e96;
    }
  }
`;

const LawContentList = (props) => {
  const { match } = props;
  const { t, i18n } = useTranslation();
  const paramsId = match.params.id;
  const [lawContentListData, setLawContentListData] = useState(null);
  const [lawHeadSettingName, setLawHeadSettingName] = useState(null);
  const [lawHeadSettingNameEN, setLawHeadSettingNameEN] = useState(null);
  const [lawHeadSettingData, setLawHeadSettingData] = useState(null);
  useEffect(() => {
    var data = JSON.stringify({
      params: {
        lawHeadSettingId: paramsId,
      },
      show: 1000,
      page: 1,
      orderBy: "lawSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/lawsettinglist`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setLawContentListData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    var data = JSON.stringify({
      params: {
        lawHeadSettingId: paramsId,
      },
      show: 100,
      page: 1,
      orderBy: "lawHeadSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/lawheadsettinglist`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setLawHeadSettingData(response.data);
        setLawHeadSettingName(response.data.data[0].lawHeadSettingName);
        setLawHeadSettingNameEN(response.data.data[0].lawHeadSettingNameEN);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [paramsId]);
  return (
    <>
      <Layout>
        {lawContentListData != null ? (
          <Container>
            <Row>
              <Col className="mt-5 mb-5 text-center">
                <h5 className="mb-2">
                  <strong>
                    {i18n.language === "th"
                      ? lawHeadSettingName
                      : lawHeadSettingNameEN || lawHeadSettingName}
                  </strong>
                </h5>
              </Col>
            </Row>

            {lawContentListData.data.length > 0 && (
              <Row style={{paddingBottom: 50}}>
                <Col md="12">
                  <lawContent>
                    {lawContentListData.data.map((item, key) => {
                      return (
                        <StyledMedia className="media">
                          <div className="media-body">
                            <div>
                              {i18n.language === "th"
                                ? item.lawSettingName
                                : item.lawSettingNameEN || item.lawSettingName}
                            </div>
                          </div>
                          <a
                            className="file"
                            download
                            href={
                              item.lawSettingFileName
                                ? `${baseUrl}/${item.lawSettingFileName}`
                                : ""
                            }
                            target="_blank"
                          >
                            <FontAwesomeIcon icon={faFileLines} />
                          </a>
                        </StyledMedia>
                      );
                    })}
                  </lawContent>
                </Col>
              </Row>
            )}
          </Container>
        ) : (
          <Loading />
        )}
      </Layout>
    </>
  );
};

export default LawContentList;
